import * as React from 'react'
import { withRouter } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'
import Chip from '@material-ui/core/Chip'
import { withStyles } from '@material-ui/core/styles'


import { Api } from '../../definitions/Api'
import * as DefaultApiImage from './default-api-image.jpg'

export interface ApiCardProps {
  api: Api,
  history: any,
}

const StyledCard = withStyles({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  }
})(Card)

const StyledCardContent = withStyles({
  root: {
    flexGrow: 1,
  }
})(CardContent)

const StyledCardActions = withStyles({
  root: {
    justifyContent: "space-between",
    marginLeft: "20%",
    marginRight: "20%"
  }
})(CardActions)

const StyledChip = withStyles({
  root: {
    marginLeft: '5px',
    height: '60%'
  }
})(Chip);


class ApiCard extends React.Component<ApiCardProps, any> {
  constructor(props: any) {
    super(props);
    this.state = { toSwagger: false };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(): void {
    this.props.history.push(`/apis/${this.props.api.id}/swagger`)
  }

  formatTitle(str: string): string {
    return (str.replace(/-/g, " ")).toUpperCase()
  }

  render() {
    return (
      <StyledCard>
        <CardActionArea onClick={this.handleClick}>
          <CardMedia
            component="img"
            image={DefaultApiImage}
            title="img"
          />
          <StyledCardContent>
            <Typography gutterBottom variant="title" component="h2" align="center">
              {this.formatTitle(this.props.api.name)}
            </Typography>
            <Typography component="div" align="center">
              Version
              <StyledChip label={this.props.api.version || 'dev'} />
            </Typography>
            <Typography gutterBottom variant='caption' align="center">
              {this.props.api.creationDate}
            </Typography>
            <Typography component="p" variant="body2" align="center">
              {this.props.api.description || 'No description'}
            </Typography>
          </StyledCardContent>
        </CardActionArea>
        <StyledCardActions disableActionSpacing>
          <Button size="small" color="primary">
            Infos
          </Button>
          <Button size="small" color="primary">
            Settings
          </Button>
        </StyledCardActions>
      </StyledCard>
    )
  }
}

export default withRouter(ApiCard)
